import { combineReducers } from "redux";
import authReducer from "./authReducer";
import taxpayersReducer from "./admin/taxpayersReducer";
import fiscalDeviceReducer from "./admin/fiscalDeviceReducer";
import fiscalDeviceLogsReducer from "./admin/fiscalDeviceLogsReducer";
import vendingControllersReducer from "./admin/vendingControllers";
import taxReducer from "./admin/taxReducer";
import usersReducer from "./admin/users";
import businessUnitReducer from "./user/businessUnitReducer";
import certificatesReducer from "./certificatesReducer";
import intervendQueueReducer from "./intervendQueueReducer";
import vsdcFailedRequestsReducer from "./vsdcFailedRequestsReducer";
import billingInvoicesReducer from "./billingInvoicesReducer";
import invoicePrefixesReducer from "./invoicePrefixesReducer";
import apiKeysReducer from "./apiKeysReducer";
import notificationsReducer from "./admin/notifications";

export default combineReducers({
  auth: authReducer,
  taxpayers: taxpayersReducer,
  fiscalDevices: fiscalDeviceReducer,
  vendingControllers: vendingControllersReducer,
  tax: taxReducer,
  users: usersReducer,
  businessUnitReports: businessUnitReducer,
  fiscalDeviceLogs: fiscalDeviceLogsReducer,
  certificates: certificatesReducer,
  intervendQueue: intervendQueueReducer,
  vsdcFailedRequests: vsdcFailedRequestsReducer,
  billingInvoices: billingInvoicesReducer,
  invoicePrefixes: invoicePrefixesReducer,
  apiKeys: apiKeysReducer,
  notifications: notificationsReducer,
});
